import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Button,
  Skeleton,
  Alert,
  Tooltip,
} from '@mui/material';
import { Rocket } from 'lucide-mui';
import useLimits from '../../../plan/hooks/limits';
import { RootState } from '../../../../reducers';
import TranscribeJobStateDisplay from '../../TranscribeJobStateDisplay';

const SummaryEmpty = () => {
  const guardLimits = useLimits();
  const duration = useSelector(
    (state: RootState) => state.selectedVideo.file.duration
  );

  const handleUpgradeClick = () => {
    guardLimits('skipQueue', () => {
      // Handle upgrade logic here, if needed.
    });
  };

  const calculateProcessingTime = (durationInSeconds: number): number => {
    return Math.round(durationInSeconds / 7);
  };

  const processingTimeInSeconds = duration
    ? calculateProcessingTime(duration)
    : 0;

  const getTooltipText = (): string => {
    if (processingTimeInSeconds < 60) {
      return `Recordings of this length take ${processingTimeInSeconds} seconds`;
    }
    const minutes = Math.round(processingTimeInSeconds / 60);
    return `Recordings of this length take ${minutes} ${
      minutes === 1 ? 'minute' : 'minutes'
    }`;
  };

  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      {duration && !guardLimits('skipQueue') && (
        <Alert
          severity="info"
          sx={{ textAlign: 'left', mb: 1 }}
          action={
            <Tooltip title={getTooltipText()} arrow placement="top">
              <Button
                color="secondary"
                variant="outlined"
                onClick={handleUpgradeClick}
                size="small"
                style={{ whiteSpace: 'nowrap' }}
                startIcon={<Rocket />}
              >
                Skip&nbsp;the&nbsp;Wait
              </Button>
            </Tooltip>
          }
        >
          Processing takes longer during peak times. Upgrade for a speed boost.
        </Alert>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: 500, textAlign: 'left', mb: 1 }}
        >
          <TranscribeJobStateDisplay />
        </Typography>
      </Box>
      <Box>
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="80%" height={24} />
      </Box>
    </Box>
  );
};

export default SummaryEmpty;
